export const trackingReasonToListingType = {
  pin_click: 'map',
  all_objects_on_map: 'list',
};
